import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';
import { getTodaysDate } from 'src/helpers/date';

export const getDocumentsAPI = (params, config) => {
  return axiosRequest('post', serviceUrls.DOCUMENTS_FILTER, params, config);
};

export const getDocumentsTasksAPI = (params, config) => {
  return axiosRequest('post', serviceUrls.DOCUMENTS_CASE_DATA_FILTER, params, config);
};

export function searchDocuments(email) {
  return axiosRequest('get', serviceUrls.AUTOCOMPLETE_SERVICE, {
    email: email,
  });
}

export function fetchClientsService() {
  return axiosRequest('get', serviceUrls.DOCUMENTS_CLIENTS, {}, {}, null, { dateUTC: getTodaysDate('utc') });
}

export function fetchDocTypesService(clientId) {
  return axiosRequest('get', serviceUrls.DOCUMENTS_DOCUMENT_TYPES, { clientId }, {}, null, { dateUTC: getTodaysDate('utc') });
}

export function fetchEmployeesService(clientId) {
  return axiosRequest('get', serviceUrls.DOCUMENTS_EMPLOYEES, { clientId }, {}, null, { dateUTC: getTodaysDate('utc') });
}

export function fetchDocFieldsService(params) {
  return axiosRequest('get', serviceUrls.DOCUMENTS_FIELDS, params, {}, null, { dateUTC: getTodaysDate('utc') });
}

export function saveDocsService(data) {
  return axiosRequest('post', serviceUrls.DOCUMENTS_SAVE, data, {}, null, { dateUTC: getTodaysDate('utc') });
}

export function openDocumentAPI(documentKey) {
  return axiosRequest('get', serviceUrls.DOCUMENTS_OPEN, { documentKey }, { timeout: 180000 });
}

export function deleteDocumentAPI(documentId) {
  return axiosRequest('post', serviceUrls.DOCUMENTS_DELETE, { documentId: documentId });
}

export function deleteDocumentWithCaseDocumentAPI(documentId) {
  return axiosRequest('post', serviceUrls.DOCUMENTS_DELETE_WITH_CASE_DOCUMENT, { documentId: documentId });
}

export function getDocumentDetailsAPI(documentId) {
  return axiosRequest('post', serviceUrls.DOCUMENTS_VIEW_DETAILS, { documentId: documentId });
}

export function getDocumentDetailsHeaderAPI(documentId) {
  return axiosRequest('get', serviceUrls.DOCUMENTS_GET_DETAILS_HEADER, { documentId });
}

export function getFiltersAPI(params = {}) {
  return axiosRequest('post', serviceUrls.DOCUMENTS_GET_FILTERS, params);
}

export function applyFiltersAPI(data) {
  return axiosRequest('post', serviceUrls.DOCUMENTS_FILTER, data);
}

export function fetchNewDocuments(data) {
  return axiosRequest('get', serviceUrls.DASHBOARD_DOCUMENTS, data);
}

export function saveDocUploadService(data) {
  return axiosRequest('post', serviceUrls.DOCUMENTS_SAVE_UPLOAD, data, {}, null, { dateUTC: getTodaysDate('utc') });
}

export function saveDocumentsDetail(body = {}) {
  return axiosRequest('post', serviceUrls.DOCUMENTS_SAVE_DOCUMENT_DETAIL, body);
}

export function getCaseLookupValuesAPI(documentId, caseId, isFetchAll) {
  return axiosRequest('get', serviceUrls.DOCUMENTS_GET_CASES_LOOKUP_VALUES, {
    documentId: documentId,
    caseId: caseId,
    isFetchAll: isFetchAll,
  });
}

export function getDocumentsUploadFormAPI() {
  return axiosRequest('get', serviceUrls.DOCUMENTS_GET_DOCUMENT_UPLOAD_FORM);
}

export function uploadDocumentsFormAPI(data) {
  return axiosRequest('post', serviceUrls.DOCUMENTS_UPLOAD_DOCUMENTS_FORM, data, { timeout: 180000 });
}

export function uploadDocumentsAPI(data) {
  return axiosRequest('post', serviceUrls.DOCUMENTS_UPLOAD, data);
}

export function addCasesToDocumentAPI(documentId, cases) {
  return axiosRequest('post', serviceUrls.DOCUMENTS_ADD_CASES, { documentId, cases });
}

export function getCaseLookupByCaseNumber(caseNumber) {
  return axiosRequest('get', serviceUrls.DOCUMENTS_GET_CASE_LOOKUP_FILTER, { caseNumber: caseNumber });
}
